// extracted by mini-css-extract-plugin
export var activeStyle = "rsc_hb_pagination-module--activeStyle--X6Lh6";
export var disabledStyle = "rsc_hb_pagination-module--disabledStyle--G0SRt";
export var iconLeft = "rsc_hb_pagination-module--iconLeft--P+dSR";
export var iconRight = "rsc_hb_pagination-module--iconRight--mnAgF";
export var paginationItem = "rsc_hb_pagination-module--paginationItem--PzSHh";
export var paginationWrapper = "rsc_hb_pagination-module--paginationWrapper--A1kg2";